import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { CheckBoxGroupProps } from './checkbox-group.component';
import CheckboxGroup from './checkbox-group.component';

export interface HfCheckBoxGroupProps extends CheckBoxGroupProps {
  control: Control<FieldValues>;
  name: string;
  multiSelectCheckboxType?: 'buttons' | 'checkboxes';
}

export default function HfCheckboxGroup({
  id,
  control,
  name,
  label,
  data,
  value,
  textField,
  valueField,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  className,
  multiSelectCheckboxType = 'checkboxes',
  labelStyles,
  checkboxGroupStyling,
  archivedField,
  showSelectedArchivedOptions,
}: HfCheckBoxGroupProps) {
  return (
    <OdinController
      name={name}
      control={control}
      defaultValue={value}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckboxGroup
          id={id}
          name={name}
          label={label}
          error={error?.message}
          value={value}
          onChange={onChange}
          textField={textField}
          valueField={valueField}
          data={data}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          className={className}
          multiSelectCheckboxType={multiSelectCheckboxType}
          labelStyles={labelStyles}
          checkboxGroupStyling={checkboxGroupStyling}
          archivedField={archivedField}
          showSelectedArchivedOptions={showSelectedArchivedOptions}
        />
      )}
    />
  );
}
